import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyRegularSavingPlanComponent } from './my-regular-saving-plan/my-regular-saving-plan.component';
import { FormsModule } from '@angular/forms';
import { ShareModule } from '@app/shared/shared.module';
import { MyRetirementPlanComponent } from '@app/features/my-financial/my-retirement-plan/my-retirement-plan.component';
import { MyIncomeProtectionComponent } from '@app/features/my-financial/my-income-protection/my-income-protection.component';
import { MyCapitalNeedsComponent } from '@app/features/my-financial/my-capital-needs/my-capital-needs.component';
import { MyHealthPlanComponent } from '@app/features/my-financial/my-health-plan/my-health-plan.component';

@NgModule({
  declarations: [
    MyRegularSavingPlanComponent,
    MyRetirementPlanComponent,
    MyIncomeProtectionComponent,
    MyCapitalNeedsComponent,
    MyHealthPlanComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ShareModule
  ],
  exports: [
    MyRegularSavingPlanComponent,
    MyRetirementPlanComponent,
    MyIncomeProtectionComponent,
    MyCapitalNeedsComponent,
    MyHealthPlanComponent
  ]
})
export class MyFinancialModule { }



// WEBPACK FOOTER //
// ./src/app/features/my-financial/my-financial.module.ts